/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_StopInputs */



/**
* | output |
* | --- |
* | "Stop and send" |
*
* @param {Chat_Dictate_StopInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_stop = /** @type {((inputs?: Chat_Dictate_StopInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_StopInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Stoppen en verzenden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arrêter et envoyer")
	return /** @type {LocalizedString} */ ("Stop and send")
});